function sign(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; }
var ZoomProduct = /** @class */ (function () {
    function ZoomProduct(selector, options) {
        var _this = this;
        this.translate = { x: 0, y: 0 };
        this.relativePos = { x: 0, y: 0 };
        this.relativeZoom = 0;
        this.pos = { x: 0, y: 0 };
        this.scale = 1;
        this.maxScale = 1.6;
        this.haveToMove = false;
        this.isInit = false;
        this.selector = selector;
        this.event = this.selector.dataset.event;
        if (options) {
            Object.keys(options).forEach(function (key) {
                if (_this[key]) {
                    _this[key] = options[key];
                }
            });
        }
        this.init();
    }
    ZoomProduct.prototype.init = function () {
        if (this.selector) {
            this.img = this.selector.querySelector("img");
            this.isInit = true;
            this.addEventListeners();
        }
    };
    ZoomProduct.prototype.addEventListeners = function () {
        var _this = this;
        
        if (this.event === "mouse" || this.event === "both") {
            
            if (!Foundation.libs.common.isTouch) {
               
                this.selector.addEventListener("mouseout", function (e) {
                    
                        _this.setElementProp(_this.img, "transform", "scale(1)");
                    
                    
                });
                this.selector.addEventListener("mousemove", function (event) {
                     if(window.innerWidth > 640) {                       
                        event.preventDefault();
                        _this.pos.x = event.pageX - _this.selector.getBoundingClientRect().left;
                        _this.pos.y = event.pageY - _this.selector.getBoundingClientRect().top;
                        _this.mousemove();
                    }
                    return;
                });
            }
        }
        if (this.event === "touch" || this.event === "both" ) {
            this.selector.addEventListener("touchstart", function (event) {
                event.preventDefault();
                if (event.targetTouches.length == 1 && window.innerWidth > 640) {
                    _this.relativePos = {
                        x: event.targetTouches[0].pageX - _this.selector.getBoundingClientRect().left,
                        y: event.targetTouches[0].pageY - _this.selector.getBoundingClientRect().top
                    };
                    _this.haveToMove = true;
                }
                else if (event.targetTouches.length >= 2 && window.innerWidth > 640 ) {
                    _this.haveToMove = false;
                    var zoom = 0;
                    var p1 = event.targetTouches[0];
                    var p2 = event.targetTouches[1];
                    _this.relativePos = {
                        x: p1.pageX - _this.selector.getBoundingClientRect().left,
                        y: p1.pageY - _this.selector.getBoundingClientRect().top
                    };
                    _this.relativeZoom = Math.sqrt(Math.pow(p2.pageX - p1.pageX, 2) + Math.pow(p2.pageY - p1.pageY, 2)); //euclidian distance
                }
            }, supportsPassive ? { passive: true } : false);
            this.selector.addEventListener("touchend", function (event) {
                event.preventDefault();
                _this.haveToMove = false;
            });
            this.selector.addEventListener("touchmove", function (event) {
                event.preventDefault();
                if (event.targetTouches.length == 1 && _this.haveToMove && window.innerWidth > 640 ) {
                    var currentPos = {
                        x: event.targetTouches[0].pageX - _this.selector.getBoundingClientRect().left,
                        y: event.targetTouches[0].pageY - _this.selector.getBoundingClientRect().top
                    };
                    _this.touchmove(currentPos);
                }
                else if (event.targetTouches.length >= 2 && window.innerWidth > 640 ) {
                    var p1 = event.targetTouches[0];
                    var p2 = event.targetTouches[1];
                    var zoomScale = Math.sqrt(Math.pow(p2.pageX - p1.pageX, 2) + Math.pow(p2.pageY - p1.pageY, 2)); //euclidian distance
                    var delta = sign(zoomScale - _this.relativeZoom);
                    _this.zoom(delta);
                }
                else {
                    return false;
                }
            }, supportsPassive ? { passive: true } : false);
        }
    };
    ZoomProduct.prototype.throttle = function (cb, delay) {
        var _this = this;
        if (this.timerId) {
            return;
        }
        this.timerId = setTimeout(function () {
            cb();
            _this.timerId = undefined;
            return;
        }, delay);
    };
    ZoomProduct.prototype.touchmove = function (currentPos) {
        if (this.scale != 1) {
            var deltaX = (this.relativePos.x - currentPos.x) / 2;
            var deltaY = (this.relativePos.y - currentPos.y) / 2;
            var currentWidth = (this.img.clientWidth * this.scale);
            var currentHeight = (this.img.clientHeight * this.scale);
            var marginWidth = (this.selector.clientWidth / 2 - currentWidth / 2) / 2;
            var marginHeight = (this.selector.clientHeight / 2 - currentHeight / 2) / 2;
            this.translate.x += deltaX;
            this.translate.y += deltaY;
            if (this.translate.x < marginWidth) {
                this.translate.x = marginWidth;
            }
            if (this.translate.x > -marginWidth) {
                this.translate.x = -marginWidth;
            }
            if (this.translate.y < marginHeight) {
                this.translate.y = marginHeight;
            }
            if (this.translate.y > -marginHeight) {
                this.translate.y = -marginHeight;
            }
            this.setElementProp(this.img, "transform", "scale(" + this.scale + ") translateX(" + this.translate.x + "px) translateY(" + this.translate.y + "px)");
            this.relativePos.x -= deltaX;
            this.relativePos.y -= deltaY;
        }
    };
    ZoomProduct.prototype.zoom = function (delta) {
        var _this = this;
        this.throttle(function () {
            if (delta > 0 && _this.scale < _this.maxScale) {
                _this.scale = _this.scale + 0.1;
            }
            else if (delta < 0 && _this.scale > 1) {
                _this.scale = _this.scale - 0.1;
                _this.translate.x = _this.translate.x * (_this.scale - 1);
                _this.translate.y = _this.translate.y * (_this.scale - 1);
            }
            _this.setElementProp(_this.img, "transform", "scale(" + _this.scale + ") translateX(" + _this.translate.x + "px) translateY(" + _this.translate.y + "px)");
        }, 50);
    };
    ZoomProduct.prototype.setElementProp = function (element, prop, value) {
        var vendors = ["Webkit", "Moz", "ms", "O"];
        vendors.map(function (vendor) {
            return element.style[vendor + prop.charAt(0).toUpperCase() + prop.slice(1)] = value;
        });
        element.style[prop] = value;
    };
    ZoomProduct.prototype.mousemove = function () {
        this.setElementProp(this.img, "transform", "scale(" + this.maxScale + ")");
        this.setElementProp(this.img, "transformOrigin", this.pos.x + "px " + this.pos.y + "px");
    };
    /*private touchmove() {
        this.setElementProp(this.img, "transform", "scale(" + this.maxScale + ")");
        this.setElementProp(this.img, "transformOrigin", this.pos.x + "px " + this.pos.y + "px");

    }*/
    ZoomProduct.prototype.gesturePinchZoom = function (event) {
    };
    return ZoomProduct;
}());
